module.exports = __webpack_public_path__ + "img/parker-main-hero.011bf038.jpg";